export default __webpack_public_path__ + "static/heroBg-ff982e3876c4ad7af71f2d42c60b4cff.png";